import React, { Fragment, useEffect, useState } from "react";
import styles from "./Productslist.module.scss";
import DropdownIcon from "../../assets/images/arrow-square-down.svg";
import SortIcon from "../../assets/images/sort-icon.svg";
import ProductDetailModal from "./ProductModals/DetailModal";
import { format } from "date-fns";
import AddProductModal from "./ProductModals/AddProduct";
import DataTableComponent from "../Shared/Table";
import { useDispatch, useSelector } from "react-redux";
import DefaultImage from "../../assets/images/default_user.png";
import {
  clearProductSearch,
  searchProducts,
  sortProducts,
} from "../Redux/Reducer/appReducer";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";
import { getProductCategories } from "../../helpers/service";
import PageHeader from "../../global/PageHeader/PageHeader";

const ProductsList = () => {
  const { idToken } = useSelector((state) => state?.authReducer);
  const { productsSearchResults } = useSelector((state) => state?.appReducer);

  const [openAddProductModal, setOpenAddProductModal] = useState(false);
  const [openEditProductModal, setOpenEditProductModal] = useState(false);
  const [openProductDetailModal, setOpenProductDetailModal] = useState(false);
  const [currentProduct, setCurrentProduct] = useState({});
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const sortOptions = [
    "Alphabetical (A-Z)",
    "Alphabetical (Z-A)",
    "Last Modified",
  ];

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoriesData = await getProductCategories(idToken);
        setCategories(categoriesData?.data);
      } catch (error) {
        console.error("Error fetching categories: ", error);
      }
    };
    fetchCategories();
  }, [idToken]);

  const tableData = (productsSearchResults || []).map((productData) => ({
    ...productData,
    lastUpdated: productData?.updatedAt
      ? format(new Date(productData?.updatedAt), "M/d/yy h:mm a z")
      : "-",
    image: productData?.images?.[0] || DefaultImage,
    productName: productData?.name || "-",
    productCategory: productData?.category || "-",
  }));

  const productsColumns = [
    {
      name: "Product Name",
      selector: (row) => row.productName,
      sortable: false,
      center: false,
      wrap: true,
      minWidth: "30%",
      maxWidth: "30%",
      cell: (row) => (
        <div className={styles.brandname_container}>
          <div className={styles.brandname_image}>
            <img src={row.image} alt="product" width={37} height={37} />
          </div>
          <div className={styles.brand_title}>{row.productName}</div>
        </div>
      ),
    },
    {
      name: "Category",
      selector: (row) => row.productCategory,
      sortable: false,
      center: true,
      minWidth: "30%",
      maxWidth: "30%",
      cell: (row) => (
        <p className={styles.brand_table_title}>{row.productCategory}</p>
      ),
    },
    {
      name: "Last Modified",
      selector: (row) => row.lastUpdated,
      sortable: false,
      center: true,
      minWidth: "40%",
      maxWidth: "40%",
      cell: (row) => (
        <p className={styles.brand_table_title}>{row.lastUpdated}</p>
      ),
    },
  ];

  const handleSearch = (e) => {
    const query = e.target.value;
    if (query.trim() === "") {
      dispatch(clearProductSearch());
    } else {
      dispatch(searchProducts(query));
    }
  };

  const handleSort = (sortOption) => {
    dispatch(sortProducts(sortOption));
  };

  return (
    <Fragment>
      {loading && <CuteMascotSpinner />}
      {openAddProductModal || openEditProductModal ? (
        <AddProductModal
          openModal={openAddProductModal || openEditProductModal}
          toggle={() => {
            setOpenEditProductModal(false);
            setOpenAddProductModal(false);
          }}
          productData={openEditProductModal ? currentProduct : null}
          categories={categories}
          setLoading={setLoading}
        />
      ) : null}
      {openProductDetailModal ? (
        <ProductDetailModal
          openModal={openProductDetailModal}
          toggle={() => setOpenProductDetailModal(false)}
          currentProduct={currentProduct}
          setOpenEditProductModal={setOpenEditProductModal}
        />
      ) : null}
      <div className={styles.products_container}>
        <div className={styles.products_inner_container}>
          <div className={styles._page_header_wrapper}>
            <PageHeader
              title="Products"
              sortOptions={sortOptions}
              onSearch={handleSearch}
              onSort={handleSort}
              onAdd={() => setOpenAddProductModal(true)}
              addButtonLabel="Add Product"
              SortIcon={SortIcon}
              DropdownIcon={DropdownIcon}
            />
          </div>

          <div className={styles.table_container}>
            <DataTableComponent
              tableColumns={productsColumns}
              tableData={tableData}
              highlightOnHover
              onRowClicked={(row) => {
                setCurrentProduct(row);
                setOpenProductDetailModal(true);
              }}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductsList;
